import { render, staticRenderFns } from "./DataHub.vue?vue&type=template&id=51dd616c"
import script from "./DataHub.vue?vue&type=script&lang=js"
export * from "./DataHub.vue?vue&type=script&lang=js"
import style0 from "./DataHub.vue?vue&type=style&index=0&id=51dd616c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports